import React from "react";
import CONTACT from "../../config/contact";
import { Link } from "react-router-dom";
import "../../css/footer.css";
import { mithralayaFull, footer_1, footer_10, footer_11, footer_2, footer_3, footer_4, footer_6, footer_7, footer_9 } from "../../assets";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";

// Only Mithralaya's own pages are shown (set them in config/contact.js or
// the frontend .env). The old links opened @bullriseclothing.
const SOCIAL_LINKS = [
  { name: 'Instagram', icon: <FaInstagram />, url: CONTACT.social.instagram },
  { name: 'Facebook', icon: <FaFacebookF />, url: CONTACT.social.facebook },
  { name: 'YouTube', icon: <FaYoutube />, url: CONTACT.social.youtube }
].filter((s) => s.url);

const Footer = () => (
  <footer className="footer">
    <div className="footer-inner">
      <div className="footer-brand">
        <img className="footer-logo" src={mithralayaFull} alt="Mithralaya — Women's & Kids Wear" />
        <p className="footer-tagline">
          Sarees, kurtis and churidar sets for women, and everyday wear for
          kids — chosen in Chennai and delivered across India.
        </p>
        {SOCIAL_LINKS.length > 0 && <div className="footer-social">
          {SOCIAL_LINKS.map((social) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.name}
              title={social.name}
            >
              {social.icon}
            </a>
          ))}
        </div>}
      </div>

      <nav className="footer-col" aria-label="Shop">
        <h3>Shop</h3>
        <Link to="/all-product?subCategory=Saree">Sarees</Link>
        <Link to="/all-product?subCategory=Kurti">Kurtis</Link>
        <Link to="/all-product?subCategory=Churidar+Set">Churidar sets</Link>
        <Link to="/all-product?category=KIDS">Kids</Link>
        <Link to="/all-product?new=true">New in</Link>
      </nav>

      <nav className="footer-col" aria-label="Help">
        <h3>Help</h3>
        <Link to="/track-order">Track your order</Link>
        <Link to="/return-refunds">Returns &amp; refunds</Link>
        <Link to="/faqs">FAQs</Link>
        <Link to="/contact">Contact us</Link>
        <Link to="/account">My account</Link>
      </nav>

      <nav className="footer-col" aria-label="Company">
        <h3>Company</h3>
        <Link to="/about-us">About us</Link>
        <Link to="/terms-conditions">Terms &amp; conditions</Link>
        <Link to="/privacy-policy">Privacy policy</Link>
      </nav>

      <div className="footer-col footer-contact">
        <h3>Visit or call</h3>
        <address>
          {CONTACT.addressLines.map((line) => (
            <span key={line}>{line}</span>
          ))}
        </address>
        <a href={CONTACT.phoneHref}>{CONTACT.phone}</a>
        <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
      </div>
    </div>

    <div className="footer-trust">
      <div className="footer-logos">
        <span>Secure payments</span>
        <div>
          {[footer_1, footer_2, footer_3, footer_4, footer_6, footer_7].map((src, i) => (
            <img key={i} src={src} alt="" />
          ))}
        </div>
      </div>
      <div className="footer-logos">
        <span>Shipping partners</span>
        <div>
          {[footer_9, footer_10, footer_11].map((src, i) => (
            <img key={i} src={src} alt="" />
          ))}
        </div>
      </div>
    </div>

    <div className="footer-bottom">
      <span>© {new Date().getFullYear()} Mithralaya — Women's &amp; Kids Wear</span>
      <span>Cash on delivery and easy 7-day returns</span>
    </div>
  </footer>
);

export default Footer;
